const axios = require("axios");

const state = {
  // Just a test
  status: "Test test test",
};

const getters = {};

const mutations = {};

const actions = {
  // GET CALLS

  // Get all user data for statistics
  GET_ALL_USER_DATA({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/getallusers").then((response) => {
        resolve(response.data);
      });
    });
  },

  // Get all Articles
  GET_LAST_ARTICLES({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/articlelast").then((response) => {
        resolve(response.data);
      });
    });
  },

  // Get all Articles
  GET_ALL_ARTICLES({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/articlesoverview").then((response) => {
        resolve(response.data);
      });
    });
  },

  // Get all REPORT sent into the system
  GET_ALL_REPORT({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/report").then((response) => {
        resolve(response.data);
      });
    });
  },
  // Get all REPORTS connected to that article
  GET_ALL_REPORTS({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .get("/report/" + data.reporttype + "/" + data.contentid)
        .then((response) => {
          resolve(response.data);
        });
    });
  },
  // Get the REPORT_DATA of that specific report
  GET_ALL_REPORT_DATA({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .get("/report/" + data.reporttype + "/" + data.reportid + "/detail")
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          // console.log("catch")
          reject(err);
        });
    });
  },

  // UPDATE CALLS

  // Add a strike to the user, due to breaking the ToS
  ADD_USER_STRIKE(data) {
    return new Promise((resolve, reject) => {
      axios
        .post("URL", data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => reject(err));
    });
  },

  // DELETE CALLS

  // Delete the selected Report
  /*
    1. Delete_Report are the name of the action.
    2. (data) is the object we wish to find the key in
    3. return new Promise  is a promise, which means we have 2 outcomes. 
    4. axios.delete    do what it sais, runs an axios.delete call to the api
    5. ('/report/, data.id) 
      - /report/ is the location within the api i wish to look for the data.key
      - , data.id)   are the key we look for, and want to affect the report that contains this keyvalue.  which is id in this term.
    6. .then   is what we wish to do AFTER the call are made
    7. Simply runs an resolve(response.data); telling us that the call was an success.
    8. If unsuccessful, then just display that aswell

    *Note: Only works on article as a test
  */
  DELETE_REPORT(data) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/report/article/?id=/detail", data.id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => reject(err));
    });
  },

  // Delete the specific article comment
  DELETE_ARTICLE_COMMENT() {
    return new Promise((resolve, reject) => {
      axios.delete("URL").then((response) => {
        resolve(response.data);
      });
    });
  },

  TESTA({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.delete("/report/article/2/detail").then((response) => {
        resolve(response.data);
      });
    });
  },
  // Delete the article and push into archive
  DELETE_ARTICLE({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/articles", { params: { id: articleData.id } })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // POST CALLS

  // Just a test
  formstatus: (state) => state.status,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
